import { BLUECONIC_SITES } from '~/constants/BLUECONIC_SITES';

export const hasGoogleOAuth = (
  edition: string,
  propertyEndpoint?: string,
  query?: Record<string, any>,
  experiments?: string[]
): boolean => {
  if (!propertyEndpoint) return false;

  const hasExperiment =
    (query?.['mm-experiments']?.includes('google-oauth') &&
      query['mm-experiments'].includes('modal')) ||
    experiments?.some(
      (experiment) =>
        experiment.includes('google-oauth') && experiment.includes('modal')
    );
  const fansidedNetwork =
    BLUECONIC_SITES.includes(edition) && edition !== '229';
  const properties = ['swimsuit.si.com', 'www.mentalfloss.com'];

  return (
    hasExperiment ||
    properties.includes(propertyEndpoint) ||
    propertyEndpoint.endsWith('www.si.com') ||
    fansidedNetwork
  );
};
